import { facturapendiente } from './../../../shared/models/facturapendiente';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SessionService } from '../../../shared/services/session.service';
import { DataContract } from '../../../shared/models/data-contract.model';
import { Beneficiary } from '../../../shared/models/beneficiary.model';
import { BeneficiaryService } from '../../../shared/services/beneficiary.service';
import { PaymentService } from '../../../shared/services/payment.service';
import { Payment } from '../../../shared/models/payment.model';

import { ToastrService } from 'ngx-toastr';

import swal from 'sweetalert2';
import { InvoiceService } from '../../../shared/services/invoice.service';
import { DeviceUtility } from '../../../shared/utilities/device.utility';
import { FacturaContrato } from '../../../shared/models/factura-contrato.model';

declare var jQuery: any;

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.css']
})
export class StatusComponent implements OnInit {

  dataContract: DataContract;

  beneficiarios: Beneficiary[];

  quotaData: Payment;

  nombreAfiliado: string;
  direccion: string;
  telefono: string;
  ciudad: string;
  numContrato: string;
  plan: string;
  tipoContrato: string;
  formaPago: string;
  vigenciaDesde: string;
  vigenciaHasta: string;
  showPagarFactura: boolean;
  textoSaldo: string;
  valorSaldo: string;
  textoFechaCorte: string;
  valorFechaCorte: string;

  totalPagar: string;
  
  factura: string;

  showSpinnerBeneficiarios: boolean;
  showSpinnerCuotas: boolean;

  isColective: boolean;

  // El tipo de facturas que se mostraran para que el usuario
  // pueda descargarlas. El tipo 1 es factura de contrato de tipo 
  // familiar
  tipoFacturas: string = "1";

  // Es la cantidad de facturas que se podran visualizar
  numeroFacturas: string = "4";

  // Es el formato con el cual se van a visualizar
  // y descargar las facturas
  formatoFacturaArchivo: string = "PDFx";

  // Fecha mínima en la que se pueden descargar facturas 
  // con CUFE y código QR.
  // Las facturas con fechas anteriores no poseen CUFE ni código QR
  // por lo tanto no se podrán descargar.
  // En esta fecha se cambio implementación de certicamara con dispapeles.
  fechaImplementacionDispapeles : string = "2024-09-04 00:00:00.0";

  facturasContratoFamiliar: FacturaContrato[] = [];

  constructor(
    private _route: ActivatedRoute,
    private toastr: ToastrService,
    private _router: Router,
    private _sessionService: SessionService,
    private _beneficiaryService: BeneficiaryService,
    private _paymentService: PaymentService,
    private _invoiceService: InvoiceService
  ) { }

  ngOnInit() {

    this.dataContract = this._sessionService.getDataContract();

    this.showSpinnerBeneficiarios = false;
    this.showSpinnerCuotas = false;
    this.isColective = this.dataContract.colective;

    let _contractSelect = this._sessionService.getSelectContract();

    this.nombreAfiliado = this.dataContract.name;
    this.direccion = this.dataContract.addres;
    this.telefono = '';
    this.ciudad = this.dataContract.city;
    this.numContrato = _contractSelect;
    this.plan = this.dataContract.plan;
    this.tipoContrato = this.dataContract.contractType;
    this.formaPago = this.dataContract.payWay;
    this.vigenciaDesde = this.dataContract.dateStaVigency;
    this.vigenciaHasta = this.dataContract.dateEndVigency;
    this.factura = this.dataContract.factura;

    if (this._sessionService.getCurrentUser().age < 18) {
      this.showPagarFactura = false;
    }
    else {
      this.showPagarFactura = true;
    }

    this.cleanValueCosto();

    this.beneficiarios = undefined;
    this.showSpinnerBeneficiarios = true;
    this._beneficiaryService.getBeneficiariesContract(_contractSelect, this._sessionService.getCurrentUser().documentId,
      this._sessionService.getSelectDocumentTypeContracted()).subscribe(
      res => {
        this.showSpinnerBeneficiarios = false;
        this.beneficiarios = res;

      },
      err => {
        this.showSpinnerBeneficiarios = false;
        console.log(err);
      }
      )

    this.quotaData = undefined;
    this.showSpinnerCuotas = true;
    this._paymentService.getQuotaData(_contractSelect).subscribe(
      res => {
        this.showSpinnerCuotas = false;
        this.telefono = res.residentialPhone;
        this.quotaData = res;

        this.validaSaldo(this.dataContract.value, this.dataContract.valueMora, this.dataContract.valCut);
        this.validaColectivo(this.dataContract.contractType, this.dataContract.valueMora, this.dataContract.sPayValue, this.dataContract.codStateContract);
      },
      err => {
        this.showSpinnerCuotas = false;
        console.log(err);
      }
    );

    this.consultarUltimasFacturasContrato();
  }

  consultarUltimasFacturasContrato() {
    this._invoiceService.getLastInvoicesContracts(this.tipoFacturas, this.numContrato, this.numeroFacturas).subscribe(res => {
      this.facturasContratoFamiliar = res;
    })
  }

  validaSaldo(valorTotal: number, valorMora: string, fechaCorte: string) {
    this.cleanValueCosto();
    let valida = valorTotal;
    if (valida <= 0) {
      this.textoSaldo = 'Saldo a Favor';
      this.textoFechaCorte = 'Fecha Próximo Pago';
    } else {
      this.textoSaldo = 'Saldo en Mora';
      this.textoFechaCorte = 'Fecha de Pago';
    }

    this.valorSaldo = valorMora;
    this.valorFechaCorte = fechaCorte;
  }

  validaColectivo(tipoContrato: string, valorMora: string, valorAPagar: string, codEstadoContrato: string) {
    if (tipoContrato.toUpperCase().indexOf("COLECTIVO") > 0) {
      this.totalPagar = "No Aplica(Colectivo)";
      //Saldos no aplica
      this.cleanValueCosto();
    }
    else {
      if (codEstadoContrato.trim() === 'CA') {
        this.totalPagar = valorMora;
      } else {
        this.totalPagar = valorAPagar;
      }
    }
  }

  pago_online() {

    if (this.dataContract.dPayValue > 0) {

      sessionStorage.removeItem('sessionPagos');

      //console.log(this.dataContract);

      this._paymentService.getIva().subscribe(
        res => {

          let _iva = res;

          let _valorIva = (this.dataContract.dPayValue * ((_iva * 100) / 110));

          let _obj = {
            consecutivo: this.dataContract.numContractConsecutive,
            valorPago: this.dataContract.dPayValue,
            valorIva: _valorIva,
            baseIva: this.dataContract.dPayValue - _valorIva,
            email: this._sessionService.getCurrentUser().user,
            identificacion: this._sessionService.getCurrentUser().documentId,
            contrato: this._sessionService.getSelectContract(),
            hash: this.dataContract.fnMd5,
            identificaciond: '',
            nombreUsuario: this.dataContract.name,
            factura: this.dataContract.factura
          }

          sessionStorage.setItem('sessionPagos', JSON.stringify(_obj));
          this._router.navigate(['/office/account_status/payments']);

        },
        err => {
          swal({
            title: 'Pagos en Línea',
            html: '<p style="font-size:14px">Existe inconvenientes con los pagos. Por favor intente más tarde</p>',
            type: 'error',
            confirmButtonClass: 'btn btn-primary',
            buttonsStyling: false,
            focusConfirm: false
          });
          console.log(err);
        }
      )
    } else {
      swal({
        title: 'Pagos en Línea',
        html: '<p style="font-size:14px">No Tiene ningún saldo pendiente.</p>',
        type: 'info',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
    }

  }

  // Descarga una de las cuatro facturas del contrato familiar que se visualizan
  // en la sección de estado cuentas -> facturas
  descargar_factura_contrato_familiar(prefijo: string, numeroDocumento: string) {

    let facturaADescargar = this.facturasContratoFamiliar.find(f => f.prefijo == prefijo && f.numeroDocumento == numeroDocumento);

    const fechaDispapeles : number = Date.parse(this.fechaImplementacionDispapeles);
    const fechaFacturaADescargar : number = Date.parse(facturaADescargar.fechaFactura);
    
    // Verifica que la fecha de la factura sea posterior 
    // a la fecha de la implementación con dispapeles
    // para poder descargarse.
    if(fechaFacturaADescargar < fechaDispapeles) {
      swal({
        title: 'Lo Sentimos',
        html: '<p style="font-size:14px"><br>Fallo al visualizar la factura.</p>',
        type: 'error',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      
      throw new Error("Fallo al visualizar la factura.");
    }


    this._invoiceService.generatePDFInvoice(prefijo, numeroDocumento, this.formatoFacturaArchivo).subscribe(
      res => {

        // Si el dispositivo es móvil (móvil - navegador web)
        if (DeviceUtility.isMobileDevice()) {
          var blob = new Blob([res]);
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "factura_" + this._sessionService.getSelectContract() + ".pdf";
          link.click();
        }
        else {
          // Si es navegador web
          swal({
            width: 820,
            title: 'Factura en Línea',
            showCloseButton: true,
            html: `
            <object id="previewFactura" data="${window.URL.createObjectURL(res)}" type="application/pdf" width="800" height="800">            
            </object>       
            `,
            confirmButtonClass: 'btn btn-primary',
            confirmButtonText: 'Cerrar',
            allowOutsideClick: false,
            buttonsStyling: false,
            focusConfirm: false
          });
        }
      },

      err => {
        swal({
          title: 'Lo Sentimos',
          html: '<p style="font-size:14px"><br>Fallo al visualizar la factura, por favor intenta mas tarde.</p>',
          type: 'error',
          confirmButtonClass: 'btn btn-primary',
          buttonsStyling: false,
          focusConfirm: false
        });
      }
    );
  }

  private cleanValueCosto() {
    this.textoSaldo = '';
    this.valorSaldo = '';
    this.textoFechaCorte = '';
    this.valorFechaCorte = '';
  }

  infoPagosOnline() {

    let _message = `
    <div style="padding: 5px">
      <br/>      
      <p>1. Al realizar el pago a traves de nuestro sitio web tu transacción sera procesada de forma inmediata.</p>
      <p>2. Aquí puedes realizar pagos parciales a tu cuota de medicina prepagada , utilizando diferentes medios tales como Débito a tu cuenta de Ahorros/Corriente (PSE) o tarjeta de crédito.</p>
      <p>3. Contamos con el apoyo, seguridad y confianza que te brinda PagosOnline.net .</p>
    </div>    
    `;

    this.toastr.info(_message, 'Recuerda:', {
      tapToDismiss: false,
      enableHtml: true,
      timeOut: 0,
      closeButton: true,
      positionClass: 'toast-bottom-full-width'
    });

  }

  infoEnviarFacturaCorreo() {

    let _message = `
    <div style="padding: 5px">
      <p>Info Enviar Factura por correo...</p>
    </div>    
    `;

    this.toastr.info(_message, 'Envio de Factura por Correo:', {
      tapToDismiss: false,
      enableHtml: true,
      timeOut: 0,
      closeButton: true,
      positionClass: 'toast-bottom-full-width'
    });

  }

  enviar_factura() {

    this._invoiceService.getStatusActivate(this._sessionService.getSelectContract()).subscribe(
      res => {

        let _html = '';

        if (res === 'S') {
          _html += `
          <br/><br/>
            <img id="imgFacturaEnvio" src="./assets/images/on.png"  width="80" style="cursor: pointer" title="Inactivar envio factura"/>
            <div id="message"><p style="color: green; font-size:15px">El envío de Factura se encuentra Activo</p></div>
            <div style="font-size: 15px; text-align: left">
            <div id="infoLista">
              <ul>              
                <li>Al Inactivar este servicio no recibiras mas notificaciónes via e-mail de tu factura disponible en nuestro sitio web.</li>
              </ul>  
            </div>  
            </div>
          `;

        } else if (res === 'N') {

          _html += `
          <br/><br/>
            <img id="imgFacturaEnvio" src="./assets/images/off.png"  width="80" style="cursor: pointer" title="Activar envio factura"/>
            <div id="message"><p style="color: orange; font-size:15px">El envío de Factura se encuentra Inactivo</p></div>
            <div style="font-size: 15px; text-align: left">
            <div id="infoLista">
              <ul>
                <li>Al activar este servicio podras recibir oportunamente la notificación via e-mail de la ultima factura disponible en nuestro sitio web.</li>
                <li>MedPlus Medicina Prepagada nunca envía solicitudes de información personal a través de correo electrónico.</li>
                <li>Este servicio no tiene ningun costo.</li>
              </ul>
            </div>           
            </div>
          `;
        } else {

          swal({
            title: 'Lo Sentimos',
            html: '<p style="font-size:14px"><br>En estos momentos el servicio de envío de Factura no se encuentra disponible, por favor intenta mas tarde.</p>',
            type: 'error',
            confirmButtonClass: 'btn btn-primary',
            buttonsStyling: false,
            focusConfirm: false
          });
          return;
        }


        swal({
          width: 600,
          showCloseButton: true,
          title: 'Enviar Factura Por Correo Electrónico',
          html: _html,
          confirmButtonText: 'Cerrar',
          allowOutsideClick: false,
          confirmButtonClass: 'btn btn-primary',
          buttonsStyling: false,
          focusConfirm: false,
          onOpen: () => {

            jQuery("#imgFacturaEnvio").click((result) => {

              var _img = ''
              _img = jQuery("#imgFacturaEnvio").attr('src');
              _img = _img.substring((_img.lastIndexOf('/') + 1), _img.length);

              var _status = '';

              if (_img.trim() === 'on.png') {
                _status = 'N';
              } else {
                _status = 'S';
              }
              this._invoiceService.getActivate(this._sessionService.getSelectContract(), _status).subscribe(
                res => {

                  if (res) {
                    if (_img.trim() === 'on.png') {
                      jQuery("#imgFacturaEnvio").attr('src', './assets/images/off.png');
                      jQuery("#imgFacturaEnvio").attr('title', 'Activar envio factura');
                      jQuery('#message').html('<p style="color: orange; font-size:15px">Se ha Inactivado el envio de factura</p>');
                      jQuery('#infoLista').html(`
                        <ul>
                          <li>Al activar este servicio podras recibir oportunamente la notificación via e-mail de la ultima factura disponible en nuestro sitio web.</li>
                          <li>MedPlus Medicina Prepagada nunca envía solicitudes de información personal a través de correo electrónico.</li>
                          <li>Este servicio no tiene ningun costo.</li>
                        </ul>
                      `);
                    } else {
                      jQuery("#imgFacturaEnvio").attr('src', './assets/images/on.png');
                      jQuery("#imgFacturaEnvio").attr('title', 'Inactivar envio factura');
                      jQuery('#message').html('<p style="color: green; font-size:15px">Se ha Activado el envio de factura</p>');
                      jQuery('#infoLista').html(`
                      <ul>              
                        <li>Al Inactivar este servicio no recibiras mas notificaciónes via e-mail de tu factura disponible en nuestro sitio web.</li>
                      </ul>  
                    `);
                    }

                  } else {
                    jQuery('#message').html('<p style="color: red; font-size:15px">Se presento un error al generar esta solicitud</p>')
                  }

                },
                err => {
                  if (err.status === 406) {
                    jQuery('#message').html('<p style="color: red; font-size:15px">' + err.error.message + '</p>');
                  } else {
                    jQuery('#message').html('<p style="color: red; font-size:15px">Se presento un error al generar esta solicitud</p>');
                  }
                  
                }
              )


            });
          }
        });

      },
      err => {
        console.log(err);
      }
    );


  }

}



// WEBPACK FOOTER //
// /app/src/app/office/account-status/status/status.component.ts